export const FieldRowVariant = {
  TEXT: 'text',
  DATE: 'date',
};
